module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/76efdd2e29c4d2bd9b1dbb6b7ae8634b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/minimize.svg
// module id = KHn4
// module chunks = 1